import { useEffect } from 'react';

import { useAppConfig } from '../AppConfigContext';

interface Props {
	to: string;
}

const Redirect = ({ to }: Props) => {
	const { replace } = useAppConfig();

	useEffect(() => {
		replace(to);
	}, [replace, to]);

	return null;
};

export default Redirect;
